<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Deleted users</h1>

                    <a v-sanitizedHref="`/#/admin/organizations/users/active/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-users" aria-hidden="true"></i>
                        <span>Active users</span>
                    </a>

                    <a v-sanitizedHref="`/#/admin/organizations/users/locked/${tid}`" type="button" class="btn btn-link btn-sm">
                        <i class="fa fa-lock" aria-hidden="true"></i>
                        <span>Locked users</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <UsersTable v-if="users.length" :users="users"></UsersTable>
            <h4 v-else>No deleted users</h4>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, mixins } from 'vue-facing-decorator';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/commands-vue-component";
    import "@common/AdminNavigationV2.vue";
    import "@Organizations/Users/Components/UsersTable.vue";

    @Component
    export default class ActiveUsersPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        mounted() {
            this.setTitle("Deleted users");
            this.runSearchAllUsersQueryV1(this.tid, '', false, false, true);
        }

        get allUsersSearchResult() { return this.model?.AllUsersSearchResult; }
        get users() { return this.allUsersSearchResult?.Users || []; }
    }
</script>

<style scoped>
</style>